import React from 'react';
import {Headline} from '../Headline/Headline';
import {EmptyStateContent} from './EmptyStateContent';

export enum EmptyStateDataHook {
  root = 'EmptyState.root',
  title = 'EmptyState.title',
}

export const EmptyState = () => {
  return (
    <>
      <Headline />
      <EmptyStateContent />
    </>
  );
};
